module.exports = __webpack_public_path__ + "img/9788958286240.a49a126e.jpg";